import qs from 'qs'

import { LocaleIdentifier } from '../../../types/localeIdentifier'
import { getRequest, postRequest } from '../../../utils'
import { ExpenseCategorizationResponse } from './types/bookkeepingTag'
import { ScannedCategory } from './types/trainingData'

const BOOKY_SEARCH_URL = window.ENV?.BOOKY_SEARCH_URL || process.env.BOOKY_SEARCH_URL

interface CategorySuggestion {
  name: string
  id: number
  score: number
}

/* eslint-disable @typescript-eslint/naming-convention */
interface SuggestionMeta {
  user_id: string
  file_id: string | null
  category_id: number | null
}
/* eslint-enable @typescript-eslint/naming-convention */

/* eslint-disable @typescript-eslint/naming-convention */
export interface FetchCategorySuggestionsOptions {
  session_id: string
  text_input: string
  contact_vat_number: string
  contact_reg_number: string
  contact_country: string
  user_locale: LocaleIdentifier
  organization_id: string
  organisation_country_code: string
  scanned_category_result: ScannedCategory[] | null
  meta: SuggestionMeta
}
/* eslint-enable @typescript-eslint/naming-convention */

/* eslint-disable @typescript-eslint/naming-convention */
interface FetchCategorySuggestionsResponseData {
  query_id: string
  suggested: CategorySuggestion[]
}
/* eslint-enable @typescript-eslint/naming-convention */

export const fetchCategorySuggestionsOldMLModel = (
  options: FetchCategorySuggestionsOptions,
): Promise<FetchCategorySuggestionsResponseData> => {
  return postRequest(`${BOOKY_SEARCH_URL}/category-search/search/`, options)
}

type FetchCategorySuggestionsNewMLModelOptions = FetchCategorySuggestionsOptions & {
  isModelSearchEnabled: boolean
}

export const fetchCategorySuggestionsNewMLModel = (
  options: FetchCategorySuggestionsNewMLModelOptions,
): Promise<FetchCategorySuggestionsResponseData> => {
  return postRequest(`/ml-categorysearch/search?is_model_search=${options.isModelSearchEnabled}`, options)
}

interface FetchBookkeepingCategoriesOptions {
  organizationId?: string
  locale?: string
  categoryIds?: number[] | string[] | (number | string)[]
}

export const fetchBookkeepingCategories = ({
  categoryIds,
  locale,
  organizationId,
}: FetchBookkeepingCategoriesOptions): Promise<ExpenseCategorizationResponse> => {
  const queryParams = qs.stringify({
    ...(organizationId ? { organizationId } : {}),
    ...(categoryIds ? { categoryIds } : {}),
  })

  return getRequest(`/v2/expenseCategorization/categories?${queryParams}`, {
    'Accept-Language': locale || 'da_DK',
  })
}
